import actionTypes from '@context/actionTypes';
import { store } from '@context/store';
import { useContext } from 'react';

export default function useEducationalModule() {
  const { dispatch, state } = useContext(store);
  const { educationalModalOpen, educationalModuleExperiment } = state;

  const toggleEducationalModuleModal = () => {
    dispatch({
      type: actionTypes.SET_EDUCATIONAL_MODAL_OPEN,
      payload: !educationalModalOpen,
    });
  };

  return {
    educationalModuleExperiment,
    educationalModalOpen,
    toggleEducationalModuleModal,
  };
}
